export default __webpack_public_path__ + "static/2-01ee503e2c3604f59edc0762a00f01fc.png";